var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"option-button"},[_c('button',{staticClass:"button",style:(_vm.disabled ? 'background-color: gray !important' : ''),attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }